export const TABS_ADD_TAB = 'TABS_ADD_TAB'
export const TABS_ADD_TAB_FROM_OLD = 'TABS_ADD_TAB_FROM_OLD'
export const TABS_REMOVE_TAB = 'TABS_REMOVE_TAB'
export const TABS_REMOVE_TAB_FROM_OLD = 'TABS_REMOVE_TAB_FROM_OLD'
export const TABS_ACTIVE_TAB = 'TABS_ACTIVE_TAB'
export const TABS_SET_TAB_TEXT = 'TABS_SET_TAB_TEXT'

export const TABS_NEW_TAB_ADDED = 'TABS_NEW_TAB_ADDED'
export const TABS_TAB_REMOVED = 'TABS_TAB_REMOVED'
export const TABS_TAB_ACTIVATED = 'TABS_TAB_ACTIVATED'
export const TAB_ACTIVATE_ON_CLICK = 'TAB_ACTIVATE_ON_CLICK'
